import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-modal';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import localizedStrings from 'portfolio-shared/util/localizedStrings';
import './DialogPanel.css';

const DIALOG_PANEL_SAVE_BUTTON_ID = 'dialog-panel-save-button';

class DialogPanel extends Component {
  static propTypes = {
    activePanelId: PropTypes.string,
    afterOpen: PropTypes.func,
    children: PropTypes.node.isRequired,
    closeAfterSave: PropTypes.bool,
    contentStyle: PropTypes.object,
    customButtonText: PropTypes.string,
    dataTestName: PropTypes.string,
    dialogFocusId: PropTypes.string,
    handleKeyDown: PropTypes.func,
    hideDialogPanel: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    isOkEnabled: PropTypes.func,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    panelHeader: PropTypes.node, // override the entire panel header (title & subtitle)
    panelId: PropTypes.string.isRequired,
    panelSubtitle: PropTypes.string,
    panelTitle: PropTypes.string,
    showCancel: PropTypes.bool,
    lowerLeftButtonText: PropTypes.string,
    onClickLowerLeftButton: PropTypes.func,
  };

  static defaultProps = {
    panelTitle: 'Default Panel Title',
    isOkEnabled: () => true,
    onClose: () => {},
    onSave: () => {},
  };

  constructor() {
    super();
    this.onRequestClose = this.onRequestClose.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSave = this.onSave.bind(this);
    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.onAfterOpen = this.onAfterOpen.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  // this is called when the esc key is clicked
  onRequestClose() {
    this.onClose();
  }

  onClose() {
    this.props.onClose();
    this.props.hideDialogPanel();
  }

  onSave() {
    if (this.props.isOkEnabled()) {
      this.props.onSave();
      if (this.props.closeAfterSave !== false) {
        this.onClose();
      }
    }
  }

  isOkEnabled() {
    if (this.props && this.props.isOkEnabled) {
      return this.props.isOkEnabled();
    } else {
      return true;
    }
  }

  handleKeyDown(e) {
    let wasHandled = false;
    if (this.props.handleKeyDown) {
      wasHandled = this.props.handleKeyDown(e);
    }
    if (!wasHandled && e.keyCode === 13) {
      this.onSave();
    }
  }

  onAfterOpen() {
    if (this.props.dialogFocusId) {
      const target = document.getElementById(this.props.dialogFocusId);
      if (target) {
        target.focus();
        if (target.select) {
          target.select();
        }
      }
    }
    if (this.props.afterOpen) {
      this.props.afterOpen();
    }
  }

  render() {
    const modalStyles = {
      overlay: {
        backgroundColor: 'rgba(127, 127, 127, 0.65)',
        zIndex: 4,
      },
      content: {
        width: '800px',
        height: '700px',
        backgroundColor: '#fff',
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        overflow: 'hidden',
      },
    };

    if (this.props.contentStyle) {
      modalStyles.content = {
        ...modalStyles.content,
        ...this.props.contentStyle,
      };
    }

    const isPanelOpen = this.props.panelId === this.props.activePanelId;
    const customButtonText = this.props.customButtonText
      ? this.props.customButtonText
      : this.props.intl.formatMessage(localizedStrings.Save);
    const showCancel = this.props.showCancel !== false;

    return (
      <Modal
        contentLabel="Modal Dialog"
        style={modalStyles}
        className="dialog-panel"
        onRequestClose={this.onRequestClose}
        shouldCloseOnOverlayClick={false}
        closeTimeoutMS={150}
        isOpen={isPanelOpen}
        onAfterOpen={this.onAfterOpen}
      >
        {this.props.panelHeader}
        {!this.props.panelHeader && (
          <div
            className="dialog-panel-header"
            data-test-name={this.props.dataTestName || 'dialog-panel-modal'}
          >
            <span className="dialog-panel-title">{this.props.panelTitle}</span>
            <br />
            <span
              className={
                this.props.panelSubtitle
                  ? 'dialog-panel-subtitle'
                  : 'dialog-panel-hidden'
              }
            >
              {this.props.panelSubtitle}
            </span>
          </div>
        )}

        <div className="dialog-panel-body" onKeyDown={this.handleKeyDown}>
          {this.props.children}
        </div>

        <div className="dialog-panel-buttons-container">
          <div>
            {this.props.lowerLeftButtonText && (
              <button
                className="shared-button"
                onClick={this.props.onClickLowerLeftButton}
                data-test-name="reset-defaults"
              >
                {this.props.lowerLeftButtonText}
              </button>
            )}
          </div>
          {(() => {
            if (showCancel) {
              return (
                <button
                  className="shared-button"
                  onClick={this.onRequestClose}
                  data-test-name="cancel"
                >
                  <FormattedMessage {...localizedStrings.Cancel} />
                </button>
              );
            }
          })()}
          <button
            id={DIALOG_PANEL_SAVE_BUTTON_ID}
            className={
              this.isOkEnabled()
                ? 'shared-button-primary'
                : 'shared-button-primary-disabled'
            }
            onClick={this.onSave}
            data-test-name="save"
          >
            {customButtonText}
          </button>
        </div>
      </Modal>
    );
  }
}

export default injectIntl(DialogPanel);

export { DIALOG_PANEL_SAVE_BUTTON_ID };



// WEBPACK FOOTER //
// ./src/portfolio-shared/view/DialogPanel/DialogPanel.js